import React from 'react'
import FormEntity from '../components/FormEntity'
import hipladeTemplate from '../../common/template'
import FormEntityV2 from '../components/FormEntityV2'

function EntitiesForm() {
  return <FormEntityV2 />
}

export default hipladeTemplate(EntitiesForm)
